import type { PhotoTrayPreviewOpenSource } from './types/photo-tray-preview-open-source'
/** Hover opens after 800ms (was WMPCM-8599's ~200ms); keyboard focus after 300ms. Shared by the
 *  Photos and Backgrounds trays. */
export const PHOTO_TRAY_HOVER_OPEN_DELAY_MS = 800
export const PHOTO_TRAY_HOVER_CLOSE_DELAY_MS = 200
export const PHOTO_TRAY_FOCUS_OPEN_DELAY_MS = 300
export const PHOTO_TRAY_FOCUS_CLOSE_DELAY_MS = 0

export const PHOTO_TRAY_PREVIEW_IMAGE_WIDTH = 275
export const PHOTO_TRAY_PREVIEW_IMAGE_HEIGHT = 188
export const PHOTO_TRAY_PREVIEW_PADDING_PX = 16

/** Card height including padding — used for `alignOffset={-(previewHeight / 2)}`. */
export const PHOTO_TRAY_PREVIEW_HEIGHT =
  PHOTO_TRAY_PREVIEW_IMAGE_HEIGHT + PHOTO_TRAY_PREVIEW_PADDING_PX * 2

export const PHOTO_TRAY_PREVIEW_ALIGN_OFFSET = -Math.round(PHOTO_TRAY_PREVIEW_HEIGHT / 2)

export function photoTrayPreviewCloseDelayMs(source: PhotoTrayPreviewOpenSource | null): number {
  return source === 'focus' ? PHOTO_TRAY_FOCUS_CLOSE_DELAY_MS : PHOTO_TRAY_HOVER_CLOSE_DELAY_MS
}

export function shouldKeepPhotoTrayPreviewOpen(input: {
  pointerOverTrigger: boolean
  pointerOverContent: boolean
  focused: boolean
}): boolean {
  return input.pointerOverTrigger || input.pointerOverContent || input.focused
}

/** WMPCM-11088 / WMPCM-11796 — Right-panel Photos Escape stops propagation before canvas handlers;
 *  tray cards listen for this to close hover previews without deselecting the canvas. */
export const PHOTO_TRAY_PREVIEW_ESCAPE_DISMISS_EVENT = 'photo-tray-preview-escape-dismiss'
